import {faCamera as faCameraSolid} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

export const CameraIcon = () => {
  return (
      <FontAwesomeIcon
          icon={faCameraSolid}
          className="text-lg"
          style={{color: '#0a1F36'}}
      />
  );
}